import { useLocation } from "react-router-dom";

/**
 * Hook to determine the current route type within the SpecimenDetail view.
 * Components can call this directly instead of receiving `isMeshRoute` as a prop.
 */
export function useRouteType() {
  const location = useLocation();
  const isMeshRoute = location.pathname.includes("/mesh/");
  return { isMeshRoute };
}
